import { type ApiUnbilledContainerRent, type ApiUnbilledContainerRentGroup } from '@Model';
import { type Column } from '@synqo/frontend-component-library';
import { formatDays } from './standingFor';

const firstUnbilledDayColumn = { name: 'first_unbilled_day', label: 'Offen ab', type: 'date' } as const;

const billableDaysColumn = { name: 'billable_days', label: 'Zu berechnen' } as const;

/** The billable days, with the free days among them named when there are any. */
export const billableDaysText = (rent: Pick<ApiUnbilledContainerRent, 'billable_days' | 'free_days'>): string => {
    const days = formatDays(rent.billable_days);
    return rent.free_days > 0 ? `${days} (${rent.free_days} frei)` : days;
};

/** The columns of the groups of standing times with unbilled rent; the aggregates cannot be filtered. */
export const unbilledContainerRentColumns: Readonly<Column<ApiUnbilledContainerRentGroup>>[] = [
    { name: 'customer.display_string', label: 'Kunde' },
    { name: 'site.display_string', label: 'Standort' },
    { name: 'container_type.display_string', label: 'Containertyp' },
    { name: 'count', label: 'Anzahl', disableColumnFilter: true, disableColumnSort: true },
    { ...firstUnbilledDayColumn, disableColumnFilter: true },
    {
        ...billableDaysColumn,
        disableColumnFilter: true,
        disableColumnSort: true,
        renderCell: ({ rowData }) => formatDays(rowData.billable_days),
    },
];

/** The columns of the standing times a group is made of. */
export const unbilledContainerRentLineColumns: Readonly<Column<ApiUnbilledContainerRent>>[] = [
    {
        name: 'container.display_string',
        label: 'Container',
        renderCell: ({ rowData }) => rowData.container.display_string || '—',
    },
    { ...firstUnbilledDayColumn, disableColumnFilter: true },
    { ...billableDaysColumn, disableColumnFilter: true, renderCell: ({ rowData }) => billableDaysText(rowData) },
];
